<template>
  <div class="services-sidebar-country">
    <div v-if="mail.count != 0" class="services-sidebar-country__item">
      <img :src="mail.domain.img_path" class="--image"/>
      <div class="--name">{{ mail.domain.front_name }}</div>
      <div class="--info">
        <p>{{ getLocalization('fr.') }} {{ getPrice(mail) }} &#x20bd;</p>
        <p>{{ formatCount(mail.count) }}</p>
      </div>
      <div class="--button">
        <button class="button primary btn-w-77" @click.stop="handleBuyMail">
          {{ getLocalization('Buy') }}
        </button>
      </div>
    </div>

    <div v-else class="services-sidebar-country__item">
      <img :src="mail.domain.img_path" class="--image"/>
      <div class="--name">{{ mail.domain.front_name }}</div>
      <div class="--info --zero-count">
        <p>{{ getLocalization('fr.') }} {{ getPrice(mail) }} &#x20bd;</p>
        <p>{{ getLocalization('It will be available soon') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mail: {
      type: Object,
      required: true
    },
    individualPrices: Object,
  },
  methods: {
    getPrice(mail) {
      const key = mail.service_id + '|' + mail.domain_id;

      if (Object.hasOwn(this.individualPrices, key)) {
        return Number(this.individualPrices[key]).toFixed(2);
      }

      return Number(mail.price).toFixed(2);
    },
    getLocalization(key) {
      return this.$root.getLocalization
          ? this.$root.getLocalization(key)
          : key;
    },
    formatCount(count) {
      return count > 3
          ? count + ' ' + this.getLocalization('pcs')
          : this.getLocalization('few');
    },
    handleBuyMail() {
      this.$emit('buy-mail', this.mail.domain.name, this.mail.service.activate_org_code);
    }
  }
}
</script>
